import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, HomeIcon, UsersIcon } from 'lucide-react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { useLanguage } from '../contexts/LanguageContext';
export function ThankYouReferralPage() {
  const {
    getPath
  } = useLanguage();
  return <div className="min-h-screen flex flex-col" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-527">
      <Navigation data-id="element-528" />

      <section className="flex-1 flex items-center justify-center px-4 py-32" data-id="element-529">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-lg" data-id="element-530">
          <motion.div initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} transition={{
          delay: 0.2,
          type: 'spring',
          stiffness: 200
        }} className="w-24 h-24 mx-auto mb-8 rounded-full flex items-center justify-center" style={{
          backgroundColor: 'var(--accent)'
        }} data-id="element-531">
            <UsersIcon className="w-12 h-12 text-white" data-id="element-532" />
          </motion.div>

          <h1 className="text-3xl sm:text-4xl font-bold mb-4" style={{
          color: 'var(--text-primary)'
        }} data-id="element-533">
            Welcome to the Program!
          </h1>

          <p className="text-lg mb-4" style={{
          color: 'var(--text-secondary)'
        }} data-id="element-534">
            Your referral application has been received.
          </p>

          <p className="text-base mb-8" style={{
          color: 'var(--text-muted)'
        }} data-id="element-535">
            We'll contact you within 24 hours with your unique referral link and
            all the details you need to start earning €100 per referral.
          </p>

          <div className="rounded-2xl border p-6 mb-8 text-left" style={{
          borderColor: 'var(--border)',
          backgroundColor: 'var(--bg-secondary)'
        }} data-id="element-536">
            <h3 className="font-semibold mb-3" style={{
            color: 'var(--text-primary)'
          }} data-id="element-537">
              What happens next?
            </h3>
            <ul className="space-y-2 text-sm" style={{
            color: 'var(--text-secondary)'
          }} data-id="element-538">
              <li className="flex items-start gap-2" data-id="element-539">
                <span style={{
                color: 'var(--accent)'
              }} data-id="element-540">
                  1.
                </span>
                We'll review your application
              </li>
              <li className="flex items-start gap-2" data-id="element-541">
                <span style={{
                color: 'var(--accent)'
              }} data-id="element-542">
                  2.
                </span>
                You'll receive your unique referral link
              </li>
              <li className="flex items-start gap-2" data-id="element-543">
                <span style={{
                color: 'var(--accent)'
              }} data-id="element-544">
                  3.
                </span>
                Share the link and earn €100 for each successful referral
              </li>
            </ul>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-545">
            <a href={getPath('')} className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl font-semibold transition-all hover:scale-105" style={{
            backgroundColor: 'var(--accent)',
            color: '#FFFFFF'
          }} data-id="element-546">
              <HomeIcon className="w-5 h-5" data-id="element-547" />
              Back to Home
            </a>
          </div>
        </motion.div>
      </section>

      <Footer data-id="element-548" />
    </div>;
}